// src/pages/Product/ViewProductDetail.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import productService from '../../services/product.service';
import '../../styles/AddPages.css';

const ViewProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await productService.getProductById(id);
        if (res.success) setProduct(res.data);
        else setError('Product not found');
      } catch {
        setError('Failed to fetch product');
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  if (loading) return <div style={{ padding: 60, textAlign: 'center', color: '#6c757d' }}>Loading...</div>;
  if (error)   return <div style={{ padding: 60, textAlign: 'center', color: '#e53e3e' }}>{error}</div>;
  if (!product) return null;

  const DetailRow = ({ label, value, highlight }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        {label}
      </span>
      <span style={{ fontSize: 15, color: highlight ? '#2e7d32' : '#1a1a1a', fontWeight: highlight ? 700 : 400 }}>
        {value || '—'}
      </span>
    </div>
  );

  return (
    <div className="add-product-page">
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/product/view">Products</a></li>
          <li className="breadcrumb-item active">{product.productName}</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Product Details</h4>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/product/view')}
          >
            ← Back
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/product/edit/${id}`)}
          >
            ✏️ Edit Product
          </button>
        </div>
      </div>

      <div className="form-card">
        <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
          {/* Photo */}
          {product.photo && (
            <div style={{ flexShrink: 0 }}>
              <img
                src={product.photo}
                alt={product.productName}
                style={{ width: 160, height: 160, objectFit: 'cover', borderRadius: 12, border: '1px solid #e2e8f0' }}
              />
            </div>
          )}

          {/* Main Info */}
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1a1a1a' }}>{product.productName}</h2>
              <span style={{
                padding: '3px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700,
                background: product.status === 'Available' ? '#e8f5e9' : product.status === 'Out of Stock' ? '#fff3e0' : '#fce4ec',
                color:      product.status === 'Available' ? '#2e7d32' : product.status === 'Out of Stock' ? '#e65100' : '#c62828',
              }}>
                {product.status}
              </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 20 }}>
              <DetailRow label="Company"          value={product.company?.name} />
              <DetailRow label="Category"         value={product.category?.name} />
              <DetailRow label="Product & Packing" value={product.productAndPacking} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, marginBottom: 20 }}>
              <DetailRow label="Rate per Unit" value={`₹${Number(product.ratePerUnit || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`} highlight />
              <DetailRow label="Items per Box" value={product.itemPerBox} />
              <DetailRow label="Rate per Box"  value={`₹${Number(product.ratePerBox || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`} highlight />
            </div>

            {product.briefDescription && (
              <div style={{ padding: '14px 16px', background: '#f8f9fa', borderRadius: 8, borderLeft: '3px solid #48bb78' }}>
                <p style={{ margin: 0, fontSize: 13, color: '#495057', lineHeight: 1.6 }}>{product.briefDescription}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProductDetail;